import "./styles.scss";
import { EventDetails } from "../../js/event-details";

const eventDetails = new EventDetails();